import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { base, coordenadacxrURL, coordenadasURL, rutasURL } from "../../API/apiurls";
import CoordenadasModal from "./CoordenadasModal";
import axios from "axios";
import Swal from "sweetalert2";
import NavBar from "../../Common/NavBar";

import buildRequestData from "./requestDataCoordenadas";
import { CoordenadasTabla } from "./CoordenadasTabla";
import { DownloadTxt } from "./DownloadTXT";
import { PaginacionUtils } from "../../Hooks/PaginacionUtils";
import { EditarElemento, GuardarElementos } from "../../Hooks/CRUDHooks";
import useErrorHandler from "../../Hooks/useErrorHandler";
import { useGlobalState } from "../../Context/GlobalStateContext";
import CoordenadasMapaModal from "./CoordenadasMapaModal";
 
export function Coordenadas() {
  const { ruta } = useParams();
  const nomRuta = localStorage.getItem("nomRuta");
  const [protocoloVista, setProtocoloVista] = useState("MT-2");
  const showExtendedLayout = ["MT-3", "MT-03", "MT-3-JSON", "MT-03-JSON"].includes(
    String(protocoloVista || "").trim().toUpperCase(),
  );

  // State variables
  const { userData } = useGlobalState();
  const { empresaId, empresaNombre } = userData;

  // Elements visibility state
  const [show, setShow] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);

  // Data for display and editing
  const [datos, setDatos] = useState([]);
  const [datosMapa, setDatosMapa] = useState([]);
  const [datosEdit, setDatosEdit] = useState(null);

  const [limp, setLimp] = useState(false);

  // Pagination state
  const [pageNumber, setPageNumber] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Retrieves error messages and the error handling function from the useErrorHandler hook
  const { errorMessage, handleErrorResponse } = useErrorHandler();

  // Function to retrieve and display data based on page
  const Listar = async (page) => {
    try {
      console.log(`${coordenadacxrURL}${ruta}?pageNumber=${page}`);
      const response = await axios.get(`${base}/coordenadas/cxr/${ruta}?pageNumber=${page}&pageSize=10`);
      setDatos(response.data.content);
      console.log(`${base}/coordenadas/cxr/${ruta}?pageNumber=${page}&pageSize=10`)
      console.log(response.data.content)
      setTotalPages(response.data.totalPages);
      // setCurrentPage(response.data.number + 0);
    } catch (error) {
      console.error("Error al cargar los datos:", error);
    }
  };

  // useEffect hook to trigger data loading when 'pageNumber' changes
  useEffect(() => {
    Listar(pageNumber);
  }, [pageNumber]);

  useEffect(() => {
    const cargarProtocoloRuta = async () => {
      try {
        const response = await axios.get(`${rutasURL}/${ruta}`);
        const codigo = String(response.data?.protocolosModel?.codigo || "MT-2").trim().toUpperCase();
        setProtocoloVista(codigo);
        localStorage.setItem("protocoloVistaCoordenadas", codigo);
      } catch (error) {
        setProtocoloVista("MT-2");
        localStorage.setItem("protocoloVistaCoordenadas", "MT-2");
      }
    };

    cargarProtocoloRuta();
  }, [ruta]);

  const handleShowModal = (t) => { 
    setShow(true);
    if (t == "Nuevo") {
      setLimp(true);
    }
  };

  const handleShowMapModal = async () => {
    try {
      const response = await axios.get(`${coordenadasURL}/ruta/${ruta}`);
      setDatosMapa(response.data || []);
      setShowMapModal(true);
    } catch (error) {
      handleErrorResponse(error);
    }
  };

  // Function to close the modal and reset data
  const handleCerrar = () => {
    setShow(false);
    setLimp(false);
    setDatosEdit("");
  };

  // Function to display the modal and load data for editing
  const datosAEditar = (camion) => {
    setDatosEdit(camion);
    setShow(true);
  };
 
  // Function to save new data and handle the response
  const handleGuardar = (datosFormulario) => {
    console.log(datosFormulario);
    const requestData = buildRequestData(datosFormulario, ruta);
    GuardarElementos(`${coordenadasURL}`, requestData, datos, setDatos)
      .then(() => {
        Listar(pageNumber);
        setShow(false);
        //datosEdit(null);
      })
      .catch(handleErrorResponse);
  };

  // Function to edit data and handle the response
  const handleEditar = async (dato) => {
    try {
      const requestData = buildRequestData(dato, ruta);
      await EditarElemento(`${coordenadasURL}/${dato.id}`, requestData).then(() => {
        // datosEdit(null);
      });
      setShow(false);
      Listar(pageNumber);

    } catch (error) {
      handleErrorResponse(error);
    }
  };

  // Function to perform logical deletion (disable) of data and handle the response
  const handleEliminar = (id) => {
    Swal.fire({
      title: "¿Esta seguro de eliminar este registro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminarlo",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${coordenadasURL}/${id}`)
          .then(() => {
            const nuevosDatos = datos.filter((coordenada) => coordenada.id !== id);
            setDatos(nuevosDatos);
            Swal.fire("Eliminado", "El registro ha sido eliminado", "success");
          })
          .catch(handleErrorResponse);
      }
    });
  };

  return (
    <>
      <NavBar />
      <div className={`camionesMenu-contenedor ${showExtendedLayout ? "coordenadas-container--wide" : ""}`}>
        <CoordenadasTabla
          datos={datos}
          datosAEditar={datosAEditar}
          handleEliminar={handleEliminar}
          handleShowModal={handleShowModal}
          handleShowMapModal={handleShowMapModal}
          protocoloVista={protocoloVista}
        />
        <PaginacionUtils setPageNumber={setPageNumber} setCurrentPage={setCurrentPage} currentPage={currentPage} totalPages={totalPages} />
        {protocoloVista === "MT-1" ? (
          <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 16 }}>
            <DownloadTxt ruta={ruta} />
          </div>
        ) : null}
      </div>
      <CoordenadasModal
        handleGuardar={handleGuardar}
        mostrar={show}
        cerrar={handleCerrar}
        guardar={handleGuardar}
        datosaeditar={datosEdit}
        editar={handleEditar}
        limp={limp}
        protocoloVista={protocoloVista}
      />
      <CoordenadasMapaModal show={showMapModal} onHide={() => setShowMapModal(false)} coordenadas={datosMapa} routeName={nomRuta} />
    </>
  );
}
